module.exports = __webpack_public_path__ + "static/media/embed.683bd251.svg";